// src/App.jsx
import React from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import PropertiesSection from './components/PropertiesSection';
import Footer from './components/Footer';
import './App.css';
import NearbyAttractions from './components/NearbyAttractions';
import AboutSection from './components/AboutSection';

function App() {
  return (
    <div className="App">
      <Header />
      <HeroSection />
      <FeaturesSection />
      <PropertiesSection />
      <NearbyAttractions />
      <AboutSection />
      <Footer />
    </div>
  );
}

export default App;
